(function () {
  const sections = document.querySelectorAll('.custom-newsletter-subscribe');
  if (!sections.length) return;

  const FACTOR = 12;
  const MOBILE_BREAKPOINT = 750;

  function initSection(section) {
    // Move custom ID to the topmost Shopify section wrapper, so anchors hit the outer section.
    if (section.id) {
      const wrapper = section.closest('.shopify-section');
      if (wrapper) {
        wrapper.id = section.id;
        section.removeAttribute('id');
      }
    }

    const box = section.querySelector('.custom-newsletter-subscribe__box');
    const images = section.querySelectorAll('.custom-newsletter-subscribe__abs-image');
    if (!box || !images.length) return;

    let rafId = null;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;
    const lerp = 0.08;

    function updatePosition(e) {
      const rect = box.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      targetX = (x - 0.5) * 2;
      targetY = (y - 0.5) * 2;
      if (rafId === null) rafId = requestAnimationFrame(animate);
    }

    function animate() {
      rafId = null;
      currentX += (targetX - currentX) * lerp;
      currentY += (targetY - currentY) * lerp;

      images.forEach((img, i) => {
        const depth = 0.4 + (i % 3) * 0.3;
        const dx = currentX * FACTOR * depth;
        const dy = currentY * FACTOR * depth;
        img.style.transform = `translate(${dx}px, ${dy}px)`;
      });

      if (Math.abs(targetX - currentX) > 0.001 || Math.abs(targetY - currentY) > 0.001) {
        rafId = requestAnimationFrame(animate);
      }
    }

    function onMouseMove(e) {
      if (window.innerWidth < MOBILE_BREAKPOINT) return;
      updatePosition(e);
    }

    function onMouseLeave() {
      if (window.innerWidth < MOBILE_BREAKPOINT) return;
      targetX = 0;
      targetY = 0;
      function reset() {
        currentX += (targetX - currentX) * lerp;
        currentY += (targetY - currentY) * lerp;
        images.forEach((img, i) => {
          const depth = 0.4 + (i % 3) * 0.3;
          const dx = currentX * FACTOR * depth;
          const dy = currentY * FACTOR * depth;
          img.style.transform = `translate(${dx}px, ${dy}px)`;
        });
        if (Math.abs(currentX) > 0.01 || Math.abs(currentY) > 0.01) requestAnimationFrame(reset);
      }
      requestAnimationFrame(reset);
    }

    box.addEventListener('mousemove', onMouseMove, { passive: true });
    box.addEventListener('mouseleave', onMouseLeave);
  }

  sections.forEach(initSection);
})();
